import { useForm } from 'react-hook-form';
import { Button, Stack } from '@chakra-ui/react';
import { Dialog } from '@halo/ui-react';
import { useAppStore } from '@halo/chat-sdk-react';
import type { EditItem, FormValues } from './helpers';
import { useFields } from './helpers';

interface EditFormDialogProps {
  item: EditItem;
  show: boolean;
  setShow: (show: boolean) => void;
  title: string;
  handleUpdateProfileUser?: () => void;
}

export function EditFormDialog({
  item,
  show,
  setShow,
  title,
  handleUpdateProfileUser,
}: EditFormDialogProps) {
  const { user } = useAppStore();
  const { t } = useTranslation();
  const form = useForm<FormValues>();

  const { fields, loading, onSubmit } = useFields(
    item,
    setShow,
    form,
    user,
    handleUpdateProfileUser
  );

  return (
    <Dialog.Root
      placement="center"
      open={show}
      onOpenChange={(details) => {
        if (!details.open) {
          form.reset();
        }
        setShow(details.open);
      }}
    >
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content rounded="xl" w="480px" bg="bg.subtle">
          <Dialog.Header pt="5" px="5" pb="2.5" justifyContent="space-between">
            <Dialog.Title fontWeight="semibold">{title}</Dialog.Title>
          </Dialog.Header>
          <Dialog.Body>
            <form>
              <Stack gap="4" align="flex-start">
                {fields}
              </Stack>
            </form>
          </Dialog.Body>
          <Dialog.Footer>
            <Dialog.ActionTrigger asChild>
              <Button variant="subtle" color="fg" bg="bg.subtle" rounded="xl" minW="96px">
                {t('buttons.cancel')}
              </Button>
            </Dialog.ActionTrigger>
            <Button type="submit" rounded="xl" minW="96px" onClick={onSubmit} loading={loading}>
              {t('buttons.save')}
            </Button>
          </Dialog.Footer>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
}
